<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ item.id ? 'Edit' : 'New' }} DOB Permit Type</p>
            </header>
            <section class="modal-card-body">
                <o-field label="Description" :type="fieldType('title')" :message="getError('title')">
                    <o-input v-model="copy.title"></o-input>
                </o-field>

                <o-field label="Code" :type="fieldType('code')" :message="getError('code')">
                    <o-input v-model="copy.code"></o-input>
                </o-field>

                <div class="field">
                    <o-checkbox v-model="copy.is_active">
                        {{ copy.is_active ? 'Active' : 'Inactive' }}
                    </o-checkbox>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>

                <button @click.prevent="handleSubmit" class="button is-primary" v-submit="submitting">
                    Save
                </button>
            </footer>
        </div>
    </form>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import HandlesForm from './../../mixins/HandlesForm'

    export default {
        mixins: [HandlesForm],

        data() {
            return {
                copy: {
                    type: 'dob',
                    title: '',
                    code: '',
                    is_active: true
                }
            }
        },

        methods: {
            ...mapActions(['createOrUpdatePermitType']),

            handleSubmit() {
                let submit = this.wrapSubmit(this.createOrUpdatePermitType)

                submit(this.copy)
                    .then(res => {
                        this.successMessage('DOB Permit Type has been successfull created')
                        this.$parent.$parent.$emit('update:active', false)
                        return res
                    })
            }
        },
    }
</script>